import {QueryClient} from '@tanstack/react-query';

// Application defaults preserved from App.tsx. Mutations can invalidate cached
// read models even while their last observer is unmounted.
export const crmQueryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      refetchOnMount: false,
      retryOnMount: false,
      staleTime: 5 * 60 * 1000,
    },
  },
});
